import { forwardRef, type InputHTMLAttributes } from 'react';

/**
 * Native month-input med max som begränsar året till 4 siffror.
 * Utan max kan Chromium acceptera upp till 6 siffror i årsfältet.
 */
export const MONTH_INPUT_MAX = '9999-12';
export const MONTH_INPUT_MIN = '1000-01';

export type MonthInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

const MonthInput = forwardRef<HTMLInputElement, MonthInputProps>(function MonthInput(
  { min = MONTH_INPUT_MIN, max = MONTH_INPUT_MAX, ...rest },
  ref,
) {
  return <input ref={ref} type="month" min={min} max={max} {...rest} />;
});

export default MonthInput;
